import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { BreadcrumbModule } from 'src/app/components/breadcrumb/breadcrumb.module';
import { TableModule } from 'src/app/table/table.module';
import { PaginatorModule } from 'src/app/components/paginator/paginator.module';
import { TenantJumpboxComponent } from './tenant-jumpbox.component';
import { TenantJumpboxRoutingModule } from './tenant-jumpbox-routing.module';
import { TenantJumpboxPopupComponent } from './tenant-jumpbox-popup/tenant-jumpbox-popup.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {SidenavHeaderModule} from 'src/app/components/sidenav-header/sidenav-header.module';
import {MatDividerModule} from '@angular/material/divider';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatCardModule} from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import {SearchFilterModule} from 'src/app/components/search-filter/search-filter.module';
import {DropdownFilterModule} from 'src/app/components/dropdown-fliter/dropdown-filter.module';
import {DefaultFilterModule} from '../../components/default-filter/default-filter.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SubscriptionTenantModule } from '../subscription-tenant/subscription-tenant.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { PageLoaderModule } from 'src/app/components/page-loader/page-loader.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import {MatMenuModule} from '@angular/material/menu';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CommonTableModule } from 'src/app/components/table/table.module';


@NgModule({
  declarations: [
    TenantJumpboxComponent,
    TenantJumpboxPopupComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    TenantJumpboxRoutingModule,
    BreadcrumbModule,
    TableModule,
    PaginatorModule,
    MatProgressSpinnerModule,
    SidenavHeaderModule,
    MatDividerModule,
    MatTabsModule,
    MatExpansionModule,
    MatCardModule,
    MatSelectModule,
    DefaultFilterModule,
    MatProgressBarModule,
    SubscriptionTenantModule,
    NgxSkeletonLoaderModule,
    PageLoaderModule,
    PipesModule,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    CommonTableModule,
    SearchFilterModule
  ]
})
export class TenantJumpboxModule { }
